const VideoEmbed = () => {
  return (
    <div
      className="wistia_responsive_padding rounded-[16px] overflow-hidden"
      style={{ padding: "56.25% 0 0 0", position: "relative" }}
    >
      <iframe
        src="https://www.youtube.com/embed/hvhqxTYaOo0?si=Dq7Y4gN-54WyFvCX&autoplay=1&mute=1&controls=0&rel=0"
        title="Zoee Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
        className="absolute inset-0 w-full h-full"
      ></iframe>
    </div>
  )
}

export default VideoEmbed
